<div class="container">
  <div class="facility-element">
    <wr-facility-element-select
      [disabled]="isDisabled"
      [(ngModel)]="selectedFacilityElement">
    </wr-facility-element-select>
  </div>
  <div>
    <wr-generic-pick-list [behaviour]="this"
                          [(ngModel)]="selectedContractors"
                          [disabled]="isDisabled">
    </wr-generic-pick-list>
  </div>
</div>

